/**
 * web vitals指标上报
 */

import {
  onFCP,
  onCLS,
  onFID,
  onLCP,
  onTTFB,
} from 'web-vitals/attribution'

export default function ({ app, $sensors, route }) {
  if (process.server) return

  const sendVitals = ({
    name,
    value,
    delta,
    rating,
  }) => {
    $sensors.track('website_vitals', {
      vitals_name: name,
      vitals_value: value,
      vitals_delta: delta,
      vitals_rating: rating,
      page_path: route.path,
    })

    const eventData = {
      event_category: 'Web Vitals',
      event_label: name,
      value: Math.round(value),
      page_path: route.path,
      rating,
    }
    switch (name) {
      case 'LCP':
        eventData.lcp_value = Math.round(value)
        eventData.lcp_rating = rating
        eventData.lcp_delta = Math.round(delta || 0)
        break
      case 'FID':
        eventData.fid_value = Math.round(value)
        eventData.fid_rating = rating
        eventData.fid_delta = Math.round(delta || 0)
        break
      case 'CLS':
        eventData.cls_value = Math.round(value * 1000)
        eventData.cls_rating = rating
        eventData.cls_delta = Math.round((delta || 0) * 1000)
        break
      case 'FCP':
        eventData.fcp_value = Math.round(value)
        eventData.fcp_rating = rating
        eventData.fcp_delta = Math.round(delta || 0)
        break
      case 'TTFB':
        eventData.ttfb_value = Math.round(value)
        eventData.ttfb_rating = rating
        eventData.ttfb_delta = Math.round(delta || 0)
        break
      default:
        break;
    }
    // 发送到GA
    // window.gtag('event', 'web_vitals', eventData)
    window?.dataLayer.push({
      event: 'web_vitals',
      eventData,
    });
  }

  app.router.onReady(() => {
    onFCP(sendVitals)
    onCLS(sendVitals)
    onFID(sendVitals)
    onLCP(sendVitals)
    onTTFB(sendVitals)
  })
}
